/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundModelComparisonRequest {
    getFixupPrototypeFunction() { return AIPlaygroundModelComparisonRequest.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundModelComparisonRequest>): AIPlaygroundModelComparisonRequest {
        let obj = Object.assign(new AIPlaygroundModelComparisonRequest(), model);
        AIPlaygroundModelComparisonRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundModelComparisonRequest>): AIPlaygroundModelComparisonRequest {
        if (!model) return null;
        return AIPlaygroundModelComparisonRequest.newInstance(<AIPlaygroundModelComparisonRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundModelComparisonRequest) {
        if (!obj) return;

        models.AIPlaygroundModelComparisonRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundModelComparisonRequest): boolean {
        Object.setPrototypeOf(obj, AIPlaygroundModelComparisonRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.models) {
            for (let val of this.models) {
                models.AIPlaygroundModelInput.fixupPrototype(val);
            }
        }
        if (this.prompts) {
            for (let val of this.prompts) {
                models.AIPlaygroundPromptInput.fixupPrototype(val);
            }
        }
    }

    /**
     * Models to invoke
     */
    models: Array<models.AIPlaygroundModelInput>;

    /**
     * Prompts to run against each model
     */
    prompts: Array<models.AIPlaygroundPromptInput>;

    /**
     * AWS service account ID
     */
    service_account_id: string;

}
